import { __module as r } from "./ghl-ui.es1727.js";
import { i as l } from "./ghl-ui.es1541.js";
import { t as m } from "./ghl-ui.es1631.js";
import { r as v } from "./ghl-ui.es1637.js";
(function(f, t) {
  var a = l.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  var u = a(m), i = a(v);
  function d(p) {
    (0, i.default)(1, arguments);
    var o = 1, e = (0, u.default)(p), s = e.getUTCDay(), n = (s < o ? 7 : 0) + s - o;
    return e.setUTCDate(e.getUTCDate() - n), e.setUTCHours(0, 0, 0, 0), e;
  }
  f.exports = t.default;
})(r, r.exports);
var U = r.exports;
export {
  U as s
};
